import { styled } from "@mui/material/styles";

/**
 * Sits directly inside LoginContainer (the centred flex row), deliberately NOT inside
 * LoginOrRegisterContainer: that one is `width: min-content`, sized around the login
 * form's fixed-width fields, and prose placed in it wraps to a couple of words per line.
 * 30rem is the same readable measure ErrorMessageContainer uses on these pages.
 */
export const SecondChanceContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: theme.space._600,
  width: "100%",
  maxWidth: "30rem",
  marginLeft: "auto",
  marginRight: "auto",
  paddingLeft: theme.space._400,
  paddingRight: theme.space._400,
}));

export const SecondChanceActions = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  gap: theme.space._300,
  alignSelf: "stretch",
  width: "100%",
}));
